<template>
  <div class="position-relative">
    <font-awesome-icon
      class="position-absolute text-black pointer"
      icon="times-circle"
      style="z-index: 100; top: 10px; right: 10px"
      v-if="clearOption"
      @click="clearInput"
    ></font-awesome-icon>
    <vue-suggestion
      :class="classes"
      :inputClasses="inputClasses + ' no_x_icon_in_search_input'"
      :items="items"
      v-model="selected"
      :setLabel="setLabel"
      :itemTemplate="itemTemplate"
      @changed="inputChange"
      @blur="handleExit"
      @selected="whenSelected"
      :placeholder="placeholder"
      :disabled="disabled"
    ></vue-suggestion>
  </div>
</template>

<script>
// import func from '../../../vue-temp/vue-editor-bridge';
import itemTemplate from "./ItemTemplate.vue";
/*
    searchURL: It's the base url that's gonna respond the array of items
    responseDataName: Name of the array coming from the request, e.g: response.data.jobs 
    whenSelected: Function executed when user select a suggestion, recives the object in parameters
    selectFirst: Choose the first element in items array, when input loses focus
    selectedEl: Element selected, expect an Object with title or name
  */

export default {
  props: {
    searchURL: {
      type: String,
      default: "",
      required: false,
    },
    responseDataName: {
      type: String,
      default: "",
      required: false,
    },
    whenSelected: {
      type: Function,
      default: function () {},
      required: false,
    },
    focusOut: {
      type: Function,
      default: function () {},
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
      required: false,
    },
    classes: {
      type: String,
      default: "",
      required: false,
    },
    inputClasses: {
      type: String,
      default: "",
      required: false,
    },
    selectFirst: {
      type: Boolean,
      default: false,
      required: false,
    },
    selectedEl: {
      type: Object,
      default: () => {},
      required: false,
    },
    itemsArray: {
      type: Array,
      default: () => [],
      required: false,
    },
    clearOption: {
      type: Boolean,
      default: false,
      required: false,
    },
    queryParamName: {
      type: String,
      default: "search",
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.selected = this.selectedEl;

    eventBus.$on(`clearAll-${this.responseDataName}`, () => {
      this.input = "";
      this.selected = {};
      this.items = [];
    });

    document.addEventListener("keydown", (event) => {
      this.keyboardSelection(event);
    });

  },
  data: (_) => ({
    items: [],
    selected: {},
    input: "",
    item_index: 0,
    itemTemplate,
  }),
  watch: {
    input: function () {
      this.$emit("input", this.input);
    },
    selectedEl() {
      this.selected = this.selectedEl;
    },
  },
  methods: {
    keyboardSelection(e) {
      if (e.keyCode === 38) {
        if (this.item_index > 0) {
          return this.item_index--;
        }
      }
      if (e.keyCode === 40) {
        if (this.item_index < this.items.length - 1) {
          return this.item_index++;
        }
      }
      if (e.keyCode === 9) {
        this.selected = this.items[this.item_index];
        if (this.selected?.name) this.whenSelected(this.selected);
      }
    },
    setLabel(item) {
      return item.title || item.name;
    },
    inputChange(text) {
      this.item_index = 0;
      this.input = text;
      if (this.itemsArray.length > 0) {
        this.searchArray(text);
        return;
      }

      axios
        .get(this.searchURL + `?${this.queryParamName}=${text}`)
        .then((response) => {
          this.items = response.data[this.responseDataName];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchArray(text) {
      text = text.toLowerCase();
      this.items = this.itemsArray.filter((item) => {
        let name = item.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        if (name.indexOf(text) >= 0) return item.name;
      });
    },
    handleExit(event) {
      this.$emit("blur", event);
      if (this.items.length == 0) return;

      // if (this.selectFirst) this.selected = this.items[0];
      this.focusOut(event, this.items, this.selectedEl);
    },
    clearInput() {
      if (this.selected.title) this.selected.title = "";
      if (this.selected.name) this.selected.name = "";
      eventBus.$emit(`clearInput-${this.responseDataName}`);
    },
  },
};
</script>
